import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CanActivateClienteInternet } from './can-activate-cliente-internet';
import { ClienteInternetComponent } from './cliente-internet.component';


@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: '',
                canActivateChild: [CanActivateClienteInternet],
                children: [
                    {path: '', component: ClienteInternetComponent},
                ]
            }
        ])
    ],
    exports: [
        RouterModule
    ],
    providers: [
        CanActivateClienteInternet
    ]
})
export class ClienteInternetRoutingModule { }
